import { authenticationErrorMessage } from './authenticationErrorMessage.js';

export function isAuthenticationResponse(location: Pick<Location, 'hash' | 'search'>): boolean {
	const parameters = new URLSearchParams(`${location.search.replace(/^\?/, '')}&${location.hash.replace(/^#/, '')}`);
	return parameters.has('state') && (parameters.has('code') || parameters.has('error'));
}

export async function completeAuthenticationRedirect(): Promise<void> {
	const container = document.getElementById('blue');
	const status = document.createElement('p');
	status.setAttribute('role', 'status');
	status.textContent = 'Completing sign-in…';
	container?.replaceChildren(status);
	try {
		const { broadcastResponseToMainFrame } = await import('@azure/msal-browser/redirect-bridge');
		await broadcastResponseToMainFrame();
		status.textContent = 'Sign-in complete. You may close this window.';
	} catch (error) {
		status.setAttribute('role', 'alert');
		status.textContent = authenticationErrorMessage(error);
		const retry = document.createElement('a');
		retry.href = `${window.location.origin}${window.location.pathname}`;
		retry.textContent = 'Return to sign in';
		container?.append(retry);
	}
}
